// extracted by mini-css-extract-plugin
export default {"root":"TemperatureDigitImagesPage_root__Ep8TW","image-results":"TemperatureDigitImagesPage_image-results__-p9va","fallback":"TemperatureDigitImagesPage_fallback__jK63s"};